export default [
    {
        path: '/login',
        name: 'Login',
        component: require('../views/Login.vue').default,
    }]
